import { defineMessages } from 'react-intl';

export default defineMessages({
  asset: 'Asset',
  stableAPY: 'Stable APY',
  variableAPY: 'Variable APY',
  availableToBorrow: 'Available to borrow',
  basedCollateral: 'Based on your collateral',
  dividerTitle: 'To borrow, deposit any of these assets into your wallet.',

  connectWallet: 'To borrow, please connect a wallet',
});
